import './styles.scss';

export default {
  name: 'ForgotPasswordQuestion',

  data() {
    return {
      email: this.$route.query.email || '',
      question: this.$route.query.question || '',
      questionId: this.$route.query.questionId,
      answer: '',
      allowLogin: true
    }
  },


  methods: {
    async authenticate() {
      if (this.answer) {
        if (this.$store.state.online_status) {

          this.loginAlert = await this.$ionic.loadingController.create({
            spinner: 'lines',
            animated: true,
            message: '',
            translucent: false,
          });

          this.loginAlert.present();

          const data = {
            email: this.email,
            SecurityQuestionId: this.questionId,
            SecurityQuestionAnswer: this.answer
          };

          this.$store
            .dispatch("securityQuestion", data)
            .then((response) => {
              this.loginAlert.dismiss();
              this.$router.push({
                path: '/forgot-password/change-password',
                query: {
                  email: this.email,
                  securityQuestionId: this.questionId,
                }
              });
            })
            .catch((error) => {
              this.loginAlert.dismiss();
              this.$ionic.alertController
                .create({
                  message: error,
                  buttons: ["OK"],
                })
                .then((a) => a.present());
            });
        } else {
          this.$ionic.alertController
            .create({
              message: "Please establish and internet connection and try again.",
              buttons: ["OK"],
            })
            .then((a) => a.present());
        }
      } else {
        let message = 'Please enter your answer.';

        this.$ionic.alertController.create({
          header: 'Error',
          message: message,
          buttons: ['OK'],
        }).then(a => a.present());
      }
    }
  }
};